/*
  add new Work data files here
  1. add new import line
  2. add new line with addContent()
*/

import DreamWorks from './dreamworks';
import HpWearable from './hp-wearable';
import LandRover from './land-rover';
import TacoRecombinator from './taco-recombinator';
import VirtualLessonPlan from './virtual-lesson-plan';

import ModuleTestPage from './module-test-page';

const workContent = {};

const addContent = (function(struct) {
  return function(content) {
    const slug = content.slug;
    // eslint-disable-next-line no-param-reassign
    struct[slug] = content;
  };
}(workContent));

addContent(DreamWorks);
addContent(HpWearable);
addContent(LandRover);
addContent(TacoRecombinator);
addContent(VirtualLessonPlan);

addContent(ModuleTestPage);

export default workContent;



// WEBPACK FOOTER //
// ./src/content/work/index.js